import Vue from 'vue'
import App from './App'
import Buefy from 'buefy'
import router from './router'
import Roles from './mixins/roles'
import store from './store'
import VueMask from 'v-mask'
import VueMeta from 'vue-meta'
// import VueSpeech from 'vue-speech'
import i18n from '@/language/i18n'
import './validation'
import './signature'

Vue.config.productionTip = false

Vue.use(Buefy)
Vue.use(VueMask)
Vue.use(VueMeta)
// Vue.use(VueSpeech)
Vue.mixin(Roles)

new Vue({
	i18n,
	router,
	store,
	render: h => h(App),
	callRoleMixin: true
}).$mount('#app')

Vue.prototype.$callRoleMixin = false
Vue.config.devtools = true
